module.exports = __webpack_public_path__ + "img/right_ring.5e8b657b.png";